import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import { useScreen } from 'common/hooks/useScreen';

/**
 * Request To Add Or Remove Trainings.
 * Contain BOX and Link component
 * @returns {JSX.Element}
 */
export const RequestToAddOrRemoveTrainings = () => {
  const screen = useScreen();
  return (
    <>
      <Box>
        <Link underline='none' href={process.env.REACT_APP_REDIRECT_URI_SKIP} target='_blank'>
          <Button
            sx={{
              float: 'right',
              marginTop: '32px',
              color: 'black',
              border: `1px solid #212121`,
              bgcolor: '#FFFFFF',
              textTransform: 'none',
              fontWeight: 500,
              width: '293px',
              height: '32px',
              borderRadius: '8px',
              fontSize: screen.isMobile || screen.isTablet ? '14px' : '16px',
              lineHeight: '16px',
              fontFamily: '"JohnsonText-Medium"',
              '&:hover': {
                backgroundColor: '#212121',
                color: `#FFFFFF`,
                fontFamily: '"JohnsonText-Medium"',
              },
              '&:focus': { outline: 'none' },
            }}
          >
            Request to Add or Remove Trainings
          </Button>
        </Link>
      </Box>
    </>
  );
};
